/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type TicketOrigin = typeof TicketOrigin[keyof typeof TicketOrigin];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketOrigin = {
  Chat: 'Chat',
  Email: 'Email',
  Phone: 'Phone',
  Web: 'Web',
  GridOperator: 'GridOperator',
  TicketAPI: 'TicketAPI',
} as const;
